import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class HomeawayLinkSerializer extends ApplicationSerializer {
  attrs = {
    status: { serialize: false },
    checkpoints: { serialize: false },
  };
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'homeaway-link': HomeawayLinkSerializer;
  }
}
